// extracted by mini-css-extract-plugin
module.exports = {"sliderWrap":"EIMcv"};